export const alloysPartnersShopifyFetchSegments = "/alloys/partners/shopify/:integration_id/fetch_segments";
